import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/LeftPanel";
import axios from "axios";
import Global from "../../APIConfig";
import { json, useNavigate, useParams } from "react-router-dom";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from '../../components/ui/toast';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { ArrowLeft, Package, HelpCircle, Plus, Trash2, MapPin, Loader2 } from "lucide-react";


/**
 * CreateShipmentContent — full booking form (all handlers intact).
 * Used both by the standalone /Createshipment page and the /Shipping hub tab.
 */
export function CreateShipmentContent() {
    let navigate = useNavigate();
    const [booking_Type, setBooking_Type] = useState('Domestic');
    const [manualAWB, setManualAWB] = useState('');
    const [todaydate, setTodayDate] = useState(getTodayDateString());
    const [currentTime, setCurrentTime] = useState(new Date());
    const [product_Type, setProduct_Type] = useState('Parcel');
    const [billtype, setBilltype] = useState('Wallet');
    const [selectedcustomer, setSelectedcustomer] = useState([]);
    const [billpayid, setBillpayid] = useState('0');
    const [sendercompanyname, setSendercompanyname] = useState('');
    const [sendercustomername, setSendercustomername] = useState('');
    const [sendermobilenumber, setSendermobilenumber] = useState('');
    const [senderemail, setSenderemail] = useState('');
    const [senderAddress, setSenderAddress] = useState('');
    const [senderPostalcode, setSenderPostalcode] = useState('');
    const [sendercountryname, setSendercountryname] = useState('');
    const [sendercountryid, setSendercountryid] = useState('');
    const [sendercityName, setSendercityName] = useState('');
    const [sendercityId, setSendercityId] = useState('');
    const [receivercompanyname, setReceivercompanyname] = useState('');
    const [receivercustomername, setReceivercustomername] = useState('');
    const [receivermobilenumber, setReceivermobilenumber] = useState('');
    const [receiveremail, setReceiveremail] = useState('');
    const [receiverAddress, setReceiverAddress] = useState('');
    const [receiverPostalcode, setReceiverPostalcode] = useState('');
    const [receivercountryname, setReceivercountryname] = useState('');
    const [receivercountryid, setReceivercountryid] = useState('');
    const [receivercityName, setReceivercityName] = useState('');
    const [receivercityId, setReceivercityId] = useState('');
    const { headers1, headers2, logout } = AuthUser();
    const [paymenttype, setPaymenttype] = useState('Prepaid');
    const [codprice, setCodprice] = useState('0');
    const [insurance, setInsurance] = useState('No');
    const formattedTime = currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const [countrylist, setCountrylist] = useState([]);
    const [defaultCountry, setDefaultCountry] = useState('');
    const [senderdefaultCountryid, setSenderDefaultCountryid] = useState('');
    const [receiverdefaultCountryid, setReceiverdefaultCountryid] = useState('');
    const [packages, setPackages] = useState([{ ProductName: "", ProductPrice: "", ProductQTY: "", Height: "", Width: "", Length: "", Weight: "" }]);
    const [servicelist, setServicelist] = useState([]);
    const [selectedservicelist, setSelectedservicelist] = useState('');
    const [setloader, setSetloader] = useState(false);
    const [userdata, setUserdata] = useState('');
    const [citylist, setCitylist] = useState([]);
    const [pincodeSenderCity, setPincodeSenderCity] = useState([]);
    const [pincodeReceiverCity, setPincodeReceiverCity] = useState([]);
    const [height, setHeight] = useState('');
    const [weight, setWeight] = useState('');
    const [length, setLength] = useState('');
    const [width, setWidth] = useState('');


    useEffect(() => {
        GetCountrylist();
        GetdefaultCountry();
        GetdefaultCountryid();
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setSelectedcustomer(items.name);
            setBillpayid(items.uniqueid);
            setSendercompanyname(items.company);
            setSendercustomername(items.name);
            setSendermobilenumber(items.phone);
            setSenderemail(items.email);
            setSenderAddress(items.address);
            setSenderPostalcode(items.pincode);
            setSendercountryname(items.countryname);
            setSendercountryid(items.country);
            setSendercityName(items.cityname);
            setSendercityId(items.city);
            setPincodeSenderCity([{ value: items.city, label: items.cityname }]);
            setUserdata(items);
        }
        const timerId = setInterval(() => {
            setCurrentTime(new Date());
        }, 10000);
        return () => clearInterval(timerId);

    }, []);

    const GetCountrylist = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'Countrylist',
            data: {
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setCountrylist(data);
                }
            })
            .catch(function (error) {
                // console.log(error);
                // setLoading(false);
            });
    }

    const GetdefaultCountryid = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'SiteconfigData',
            data: {
                fliedname: "default_country"
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setSenderDefaultCountryid(data);
                    setReceiverdefaultCountryid(data);
                    setSendercountryid(data);
                    setReceivercountryid(data);
                }
            })
            .catch(function (error) {
                // console.log(error);
                // setLoading(false);
            });
    }

    const GetdefaultCountry = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'defaultcountryname',
            data: {
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setDefaultCountry(data);
                    setSendercountryname(data);
                    setReceivercountryname(data);
                    GetCityList(data);
                }
            })
            .catch(function (error) {
                // console.log(error);
                // setLoading(false);
            });
    }

    const filterBy = (option, state) => {
        if (state.selected.length) {
            return true;
        }
        return option.label.toLowerCase().indexOf(state.text.toLowerCase()) > -1;
    }

    const handleTimeChange = (e) => {
        const [hours, minutes] = e.target.value.split(':');
        const newTime = new Date(currentTime);
        newTime.setHours(hours, minutes);
        setCurrentTime(newTime);
    };

    const addInput = () => {
        setPackages([...packages, { ProductName: "", ProductPrice: "", ProductQTY: "" }]); //,Height:"",Width:"",Length:"",Weight:""
    };
    const handleDelete = (i) => {
        const deleteVal = [...packages]
        deleteVal.splice(i, 1)
        setPackages(deleteVal);
    }

    const handlechange = (e, i) => {
        setServicelist([]);
        const { name, value } = e.target
        const onchangeVal = [...packages]
        onchangeVal[i][name] = value
        setPackages(onchangeVal);
    }

    const GetCityList = (val) => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'Citylist',
            data: {
                name: val
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setCitylist(data);
                }
            })
            .catch(function (error) {
                // console.log(error);
                // setLoading(false);
            });
    }

    const handelbilltypecustomer = (e) => {
        setBilltype(e);
    }

    const handelbillbyid = (e) => {
        const id = e[0].value;
        const name = e[0].label;
        setSelectedcustomer(name)
        setBillpayid(id);
    }

    // Function to get today's date in the format "YYYY-MM-DD"
    function getTodayDateString() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const handelsendercountry = (e) => {
        setSendercountryname(e.target.options[e.target.selectedIndex].text);
        GetCityList(e.target.options[e.target.selectedIndex].text);
        setSendercityName('');
        setSendercityId('');
        setSendercountryid(e.target.value);
        setServicelist([]);
        setPincodeSenderCity([]);
    }

    const handelreceivercountry = (e) => {
        setReceivercountryname(e.target.options[e.target.selectedIndex].text);
        GetCityList(e.target.options[e.target.selectedIndex].text);
        setReceivercityName('');
        setReceivercityId('');
        setReceivercountryid(e.target.value);
        setServicelist([]);
        setPincodeReceiverCity([]);
    }

    const handelsenderautoselectcity = (selectedOptions) => {
        setPincodeSenderCity(selectedOptions);
        if (selectedOptions.length > 0) {
            const selectedOption = selectedOptions[0];
            setSendercityName(selectedOption.label);
            setSendercityId(selectedOption.value);
        } else {
            setSendercityName('');
            setSendercityId('');
        }
        setServicelist([]);
    };

    const handelReceiverautoselectcity = (e) => {
        setPincodeReceiverCity(e)
        if (e.length > 0) {
            const id = e[0].value;
            const name = e[0].label;
            setReceivercityName(name);
            setReceivercityId(id);
        }
        else {
            setReceivercityName('');
            setReceivercityId('');
        }
        setServicelist([]);
    }

    const handelservice = () => {
        if (sendercustomername == "") {
            toast.warn('Please Enter Sender Customer Name');
        }
        else if (sendermobilenumber == "") {
            toast.warn('Please Enter Sender Customer Mobile Number');
        }
        else if (senderAddress == "") {
            toast.warn('Please Enter Sender Customer Address');
        }
        else if (sendercountryname == "") {
            toast.warn('Please Select Sender Country');
        }
        else if (sendercityName == "") {
            toast.warn('Please Select Sender City');
        }
        else if (receivercustomername == "") {
            toast.warn('Please Enter Receiver Customer Name');
        }
        else if (receivermobilenumber == "") {
            toast.warn('Please Enter Receiver Customer Mobile Number');
        }
        else if (receiverAddress == "") {
            toast.warn('Please Enter Receiver Customer Address');
        }
        else if (receivercountryname == "") {
            toast.warn('Please Select Receiver Country');
        }
        else if (receivercityName == "") {
            toast.warn('Please Select Receiver city');
        }
        else if (packages[0].ProductName == "") {
            toast.warn('Please Enter Product Name');
        }
        else if (packages[0].ProductPrice == "") {
            toast.warn('Please Enter Product Price');
        }
        else if (packages[0].ProductQTY == "") {
            toast.warn('Please Enter Product Qty');
        }
        else if (packages[0].Height == "") {
            toast.warn('1Please Enter Product Height');
        }
        else if (packages[0].Width == "") {
            toast.warn('Please Enter Product Width');
        }
        else if (packages[0].Length == "") {
            toast.warn('Please Enter Product Length');
        }
        else if (packages[0].Weight == "") {
            toast.warn('Please Enter Product Weight');
        }
        else {
            axios({
                method: 'post',
                url: Global.baseUrl + 'customershowservice',
                headers: headers1,
                data: {
                    sendercountryid: sendercountryid,
                    sendercityId: sendercityId,
                    receivercountryid: receivercountryid,
                    receivercityId: receivercityId,
                    products: packages,
                    booking_Type: booking_Type,
                    product_Type: product_Type,
                    cust_id: billpayid,
                    insurance: insurance,
                    paymenttype: paymenttype,
                    codprice: codprice,
                    type: userdata.usertype,
                    agent_id: 0,

                }
            })
                .then(function (response) {
                    if (response.data.status == 200) {
                        setServicelist(response.data.value);
                    }
                    else {
                        toast.warn(response.data.message);
                        setServicelist([]);
                    }
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                });
        }
    }

    const handelsenderpostalcode = (zipcode) => {
        setServicelist([]);
        axios({
            method: 'post',
            url: Global.baseUrl + 'countrydatabypincode',
            headers: headers1,
            data: {
                Postalcode: zipcode,
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    setSenderDefaultCountryid('');
                    setSendercountryid(response.data.value.countryid);
                    setSendercityName(response.data.value.city);
                    setSendercityId(response.data.value.id);
                    setPincodeSenderCity([{ value: response.data.value.id, label: response.data.value.city }]);
                }
                else {
                    setSendercountryid('');
                    setSendercityName('');
                    setSendercityId('');
                    setPincodeSenderCity([]);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
            });
    }

    const handelreceiverpostalcode = (zipcode) => {
        setServicelist([]);
        axios({
            method: 'post',
            url: Global.baseUrl + 'countrydatabypincode',
            headers: headers1,
            data: {
                Postalcode: zipcode,
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    setReceiverdefaultCountryid('');
                    setReceivercountryid(response.data.value.countryid);
                    setReceivercityName(response.data.value.city);
                    setReceivercityId(response.data.value.id);
                    setPincodeReceiverCity([{ value: response.data.value.id, label: response.data.value.city }]);

                }
                else {
                    setReceivercountryid('');
                    setReceivercityName('');
                    setReceivercityId('');
                    setPincodeReceiverCity([]);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
            });
    }

    const handelactiveservice = (index) => {
        const newList = servicelist[index];
        setSelectedservicelist(newList);
    }

    const createshipment = () => {
        if (sendercustomername == "") {
            toast.warn('Please Enter Sender Customer Name');
        }
        else if (sendermobilenumber == "") {
            toast.warn('Please Enter Sender Customer Mobile Number');
        }
        else if (senderAddress == "") {
            toast.warn('Please Enter Sender Customer Address');
        }
        else if (sendercountryname == "") {
            toast.warn('Please Select Sender Country');
        }
        else if (sendercityName == "") {
            toast.warn('Please Select Sender City');
        }
        else if (receivercustomername == "") {
            toast.warn('Please Enter Receiver Customer Name');
        }
        else if (receivermobilenumber == "") {
            toast.warn('Please Enter Receiver Customer Mobile Number');
        }
        else if (receiverAddress == "") {
            toast.warn('Please Enter Receiver Customer Address');
        }
        else if (receivercountryname == "") {
            toast.warn('Please Select Receiver Country');
        }
        else if (receivercityName == "") {
            toast.warn('Please Select Receiver city');
        }
        else if (packages[0].ProductName == "") {
            toast.warn('Please Enter Product Name');
        }
        else if (packages[0].ProductPrice == "") {
            toast.warn('Please Enter Product Price');
        }
        else if (packages[0].ProductQTY == "") {
            toast.warn('Please Enter Product Qty');
        }
        else if (packages[0].Height == "") {
            toast.warn('Please Enter Product Height');
        }
        else if (packages[0].Width == "") {
            toast.warn('Please Enter Product Width');
        }
        else if (packages[0].Length == "") {
            toast.warn('Please Enter Product Length');
        }
        else if (packages[0].Weight == "") {
            toast.warn('Please Enter Product Weight');
        }
        else if (selectedservicelist == "") {
            toast.warn("Please Select Service");
        }
        else {
            setSetloader(true);
            axios({
                method: 'post',
                url: Global.baseUrl + 'CreateShipmentcustomer',
                headers: headers1,
                data: {
                    booking_Type: booking_Type,
                    manualAWB: manualAWB,
                    todaydate: todaydate,
                    currentTime: formattedTime,
                    product_Type: product_Type,
                    billtype: billtype,
                    sendercompanyname: sendercompanyname,
                    sendercustomername: sendercustomername,
                    sendermobilenumber: sendermobilenumber,
                    senderemail: senderemail,
                    senderAddress: senderAddress,
                    senderPostalcode: senderPostalcode,
                    sendercityId: sendercityId,
                    sendercountryid: sendercountryid,
                    receivercompanyname: receivercompanyname,
                    receivercustomername: receivercustomername,
                    receivermobilenumber: receivermobilenumber,
                    receiveremail: receiveremail,
                    receiverAddress: receiverAddress,
                    receiverPostalcode: receiverPostalcode,
                    receivercityId: receivercityId,
                    receivercountryid: receivercountryid,
                    productsdetails: packages,
                    paymenttype: paymenttype,
                    codprice: codprice,
                    insurance: insurance,
                    servicedetails: selectedservicelist,
                    cust_id: billpayid,
                    type: userdata.usertype,
                    agent_id: 0,
                    user_id: userdata.id,
                    hub_id: 0

                }
            })
                .then(function (response) {
                    if (response.data.status == 200) {
                        toast.success(response.data.message);
                        setSetloader(false);
                        setTimeout(() => {
                            navigate('/Shipmentlist/All');
                        }, 1000);
                    }
                    else {
                        toast.warn(response.data.message);
                        setSetloader(false);
                    }
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                });
        }
    }

    const section = (title, body) => (
        <section className="px-mb">
            <h5 className="px-section-title">{title}</h5>
            <div className="px-card">
                <div className="px-card__body">{body}</div>
            </div>
        </section>
    );

    const help = (tip) => (
        <span className="px-help" title={tip} role="img" aria-label={tip}><HelpCircle size={14} /></span>
    );

    return (
        <>
            <div className="px-content">
                    <div className="px-pagehead">
                        <div className="px-pagehead__left">
                            <button className="px-btn px-btn--ghost px-btn--sm" onClick={() => navigate(-1)} aria-label="Go back">
                                <ArrowLeft size={16} />
                            </button>
                            <h2 className="px-pagehead__title">Create Shipment</h2>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-lg-8">
                            {section('Shipment Details', (
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <label className="form-label fw-semibold">Shipment Booking Type:</label>
                                        <div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" id="Domestic" checked={booking_Type == 'Domestic'} onChange={() => setBooking_Type('Domestic')} />
                                                <label className="form-check-label" for="Domestic">Domestic</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" id="International" checked={booking_Type == 'International'} onChange={() => setBooking_Type('International')} />
                                                <label className="form-check-label" for="International">International</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                        <label className="form-label fw-semibold">Shipment AWB Number <small className="text-muted">(Leave blank for auto generate)</small>:</label>
                                        <input type="text" className="form-control" placeholder="Manual Shipment AWB Number" onChange={(e) => setManualAWB(e.target.value)} />
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <label className="form-label fw-semibold">Date:</label>
                                        <input type="date" className="form-control" placeholder="Date" value={todaydate} onChange={(e) => setTodayDate(e.target.value)} />
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <label className="form-label fw-semibold">Time:</label>
                                        <input type="time" className="form-control" placeholder="Time" value={formattedTime} onChange={handleTimeChange} />
                                    </div>
                                    <div className="col-12 mb-3">
                                        <label className="form-label fw-semibold">Shipment Product Type:</label>
                                        <div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" id="Parcel" checked={product_Type == 'Parcel'} onChange={() => setProduct_Type('Parcel')} />
                                                <label className="form-check-label" for="Parcel">Parcel</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" id="Document" checked={product_Type == 'Document'} onChange={() => setProduct_Type('Document')} />
                                                <label className="form-check-label" for="Document">Document</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4 mb-3">
                                        <label className="form-label fw-semibold">Billing Type:</label>
                                        <select className="form-select" onChange={(e) => handelbilltypecustomer(e.target.value)}>
                                            <option value='Wallet'>Wallet</option>
                                            <option value='Credit' disabled={userdata.cust_credit === 'Y' ? false : true}>Credit</option>
                                            <option value='Contract' disabled={userdata.cust_credit !== 'U' ? true : false}>Contract</option>
                                        </select>
                                    </div>
                                </div>
                            ))}

                            <section className="px-mb">
                                <div className="row">
                                    <div className="col-12 col-lg-6">
                                        <h5 className="px-section-title">Add Senders Details</h5>
                                        <div className="px-card">
                                            <div className="px-card__body">
                                                <div className="row">
                                                    <div className="col-12 mb-3">
                                                        <label className="form-label fw-semibold">Company Name:</label>
                                                        <input type="text" className="form-control" value={sendercompanyname} placeholder="Company Name" onChange={(e) => setSendercompanyname(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <label className="form-label fw-semibold">Full Customer Name <span className="text-danger">*</span> :</label>
                                                        <input type="text" className="form-control" value={sendercustomername} placeholder="Customer Name" onChange={(e) => setSendercustomername(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label className="form-label fw-semibold">Mobile Number <span className="text-danger">*</span>:</label>
                                                        <input type="text" className="form-control" value={sendermobilenumber} placeholder="Mobile Number" onChange={(e) => setSendermobilenumber(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label className="form-label fw-semibold">Email ID:</label>
                                                        <input type="text" className="form-control" value={senderemail} placeholder="Email address" onChange={(e) => setSenderemail(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <label className="form-label fw-semibold">Complete Address <span className="text-danger">*</span>:</label>
                                                        <input type="text" className="form-control" value={senderAddress} placeholder="Full address" onChange={(e) => setSenderAddress(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <label className="form-label fw-semibold">Pin/Postal/Zip code:</label>
                                                        <input type="text" className="form-control" value={senderPostalcode} placeholder="Pincode" onChange={(e) => { setSenderPostalcode(e.target.value); handelsenderpostalcode(e.target.value) }} />
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <label className="form-label fw-semibold">Country <span className="text-danger">*</span>:</label>
                                                        <select className="form-select" onChange={handelsendercountry}>
                                                            <option>--Please Select--</option>
                                                            {countrylist.map((cl) => {
                                                                return (
                                                                    <option value={cl.id} key={cl.id} selected={senderdefaultCountryid === cl.id || sendercountryid === cl.id}>{cl.country}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <label className="form-label fw-semibold">City <span className="text-danger">*</span>:</label>
                                                        <Typeahead
                                                            filterBy={filterBy}
                                                            id="toggle-example"
                                                            options={citylist}
                                                            placeholder="Choose a city..."
                                                            onChange={handelsenderautoselectcity}
                                                            selected={pincodeSenderCity}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <h5 className="px-section-title">Add Receiver Details</h5>
                                        <div className="px-card">
                                            <div className="px-card__body">
                                                <div className="row">
                                                    <div className="col-12 mb-3">
                                                        <label className="form-label fw-semibold">Company Name:</label>
                                                        <input type="text" className="form-control" value={receivercompanyname} placeholder="Company Name" onChange={(e) => setReceivercompanyname(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <label className="form-label fw-semibold">Full Customer Name <span className="text-danger">*</span> :</label>
                                                        <input type="text" className="form-control" value={receivercustomername} placeholder="Customer Name" onChange={(e) => setReceivercustomername(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label className="form-label fw-semibold">Mobile Number <span className="text-danger">*</span>:</label>
                                                        <input type="text" className="form-control" value={receivermobilenumber} placeholder="Mobile Number" onChange={(e) => setReceivermobilenumber(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label className="form-label fw-semibold">Email ID:</label>
                                                        <input type="text" className="form-control" value={receiveremail} placeholder="Email address" onChange={(e) => setReceiveremail(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <label className="form-label fw-semibold">Complete Address <span className="text-danger">*</span>:</label>
                                                        <input type="text" className="form-control" value={receiverAddress} placeholder="Full address" onChange={(e) => setReceiverAddress(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <label className="form-label fw-semibold">Pin/Postal/Zip code:</label>
                                                        <input type="text" className="form-control" value={receiverPostalcode} placeholder="Pincode" onChange={(e) => { setReceiverPostalcode(e.target.value); handelreceiverpostalcode(e.target.value) }} />
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <label className="form-label fw-semibold">Country <span className="text-danger">*</span>:</label>
                                                        <select className="form-select" onChange={handelreceivercountry}>
                                                            <option>--Please Select--</option>
                                                            {countrylist.map((cl, i) => {
                                                                return (
                                                                    <option value={cl.id} selected={receiverdefaultCountryid == cl.id || receivercountryid == cl.id} key={i}>{cl.country}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <label className="form-label fw-semibold">City <span className="text-danger">*</span>:</label>
                                                        <Typeahead
                                                            filterBy={filterBy}
                                                            id="toggle-example"
                                                            options={citylist}
                                                            placeholder="Choose a city..."
                                                            onChange={handelReceiverautoselectcity}
                                                            selected={pincodeReceiverCity}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {section('Product Details', (
                                <>
                                    {packages.map((val, i) => (
                                        <div className="px-product px-mb" key={i}>
                                            <div className="px-product__num">{i + 1}</div>
                                            <div className="row">
                                                <div className="col-12 col-md-7 mb-3">
                                                    <label className="form-label fw-semibold">Product Name <span className="text-danger">*</span>:</label>
                                                    <input type="text" className="form-control" name="ProductName" placeholder="Product name" value={val.ProductName} onChange={(e) => handlechange(e, i)} />
                                                </div>
                                                <div className="col-12 col-md-3 mb-3">
                                                    <label className="form-label fw-semibold">Product Price <span className="text-danger">*</span>:</label>
                                                    <input type="number" className="form-control" name="ProductPrice" placeholder="Price" value={val.ProductPrice} onChange={(e) => handlechange(e, i)} />
                                                </div>
                                                <div className="col-12 col-md-2 mb-3">
                                                    <label className="form-label fw-semibold">Product QTY <span className="text-danger">*</span>:</label>
                                                    <input type="number" className="form-control" name="ProductQTY" placeholder="Qty" value={val.ProductQTY} onChange={(e) => handlechange(e, i)} />
                                                </div>
                                                <div className="col-6 col-md-3 mb-3">
                                                    <label className="form-label fw-semibold">Height <span className="text-danger">*</span> (CM)</label>
                                                    <input type="number" className="form-control" name="Height" placeholder="0" value={val.Height} onChange={(e) => handlechange(e, i)} />
                                                </div>
                                                <div className="col-6 col-md-3 mb-3">
                                                    <label className="form-label fw-semibold">Width <span className="text-danger">*</span> (CM)</label>
                                                    <input type="number" className="form-control" name="Width" placeholder="0" value={val.Width} onChange={(e) => handlechange(e, i)} />
                                                </div>
                                                <div className="col-6 col-md-3 mb-3">
                                                    <label className="form-label fw-semibold">Length <span className="text-danger">*</span> (CM)</label>
                                                    <input type="number" className="form-control" name="Length" placeholder="0" value={val.Length} onChange={(e) => handlechange(e, i)} />
                                                </div>
                                                <div className="col-6 col-md-3 mb-3">
                                                    <label className="form-label fw-semibold">Weight <span className="text-danger">*</span> (KG)</label>
                                                    <input type="number" className="form-control" name="Weight" placeholder="0" value={val.Weight} onChange={(e) => handlechange(e, i)} />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="px-mb">
                                        <button className="px-btn px-btn--secondary px-btn--sm" onClick={addInput}><Plus size={15} /> Add more packages</button>
                                        {packages.length > 1 &&
                                            <button className="px-btn px-btn--ghost px-btn--sm" onClick={() => handleDelete(packages.length - 1)}><Trash2 size={15} /> Remove last</button>
                                        }
                                    </div>
                                </>
                            ))}

                            {section('Order Details', (
                                <>
                                    <h6 className="fw-semibold">Payment Details</h6>
                                    <small className="text-muted">Select mode of payment that your buyer has chosen for the order</small>
                                    <div className="row mt-3">
                                        <div className="col-12 col-md-3 mb-2">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" id="inlineRadiod20" checked={paymenttype == 'Prepaid'} onChange={() => setPaymenttype('Prepaid')} />
                                                <label className="form-check-label" for="inlineRadiod20">Prepaid {help("Order Payment already received from the buyer")}</label>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4 mb-2">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" id="inlineRadiod21" checked={paymenttype == 'COD'} onChange={() => setPaymenttype('COD')} />
                                                <label className="form-check-label" for="inlineRadiod21">Cash On Delivery {help("Order Payment to be collected from the buyer on shipment delivery")}</label>
                                            </div>
                                        </div>
                                        {paymenttype == 'COD' &&
                                            <div className="col-12 col-md-4 mb-2">
                                                <input type="text" className="form-control" placeholder="COD Amount" onChange={(e) => setCodprice(e.target.value)} />
                                            </div>
                                        }
                                    </div>
                                    <hr />
                                    <h6 className="fw-semibold">Insurance</h6>
                                    <small className="text-muted">Select the insurance mode for the shipment</small>
                                    <div className="row mt-3">
                                        <div className="col-12 col-md-2 mb-2">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" id="or" value="option2" checked={insurance == 'No'} onChange={() => setInsurance('No')} />
                                                <label className="form-check-label" for="or">OR {help("Owner Risk")}</label>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-3 mb-2">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" id="cr" checked={insurance == 'Yes'} onChange={() => setInsurance('Yes')} />
                                                <label className="form-check-label" for="cr">CR {help("Carrier Risk")}</label>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ))}

                            {servicelist != undefined && servicelist.length > 0 ? (
                                <section className="px-mb">
                                    <h5 className="px-section-title">Choose shipping service</h5>
                                    {servicelist.length > 0 ? (
                                        <div className="px-service-grid">
                                            {servicelist.map((ser, i) => {
                                                return ser.totalprice > 0 ? (
                                                    <button type="button"
                                                        className={`px-service${selectedservicelist.unique_id === ser.unique_id ? ' px-service--active' : ''}`}
                                                        key={i} onClick={() => handelactiveservice(i)}>
                                                        <div className="px-service__price"><small>$</small>{ser.totalprice}</div>
                                                        <div className="px-service__name">{ser.services_name}</div>
                                                    </button>
                                                ) : null;
                                            })}
                                        </div>
                                    ) : (
                                        <div className="px-card px-card--danger">
                                            <div className="px-card__body text-center">
                                                <h6 className="text-danger">No service available for the selected locations</h6>
                                            </div>
                                        </div>
                                    )}
                                </section>
                            ) : (
                                <div className="text-center px-mb">
                                    <button type="button" className="px-btn px-btn--primary" onClick={() => handelservice()}>Show service</button>
                                </div>
                            )}
                        </div>

                        <div className="col-12 col-lg-4">
                            {sendercityName != '' &&
                                <section className="px-mb">
                                    <h5 className="px-section-title">Shipment Route</h5>
                                    <div className="px-card">
                                        <div className="px-card__body">
                                            <div className="px-timeline">
                                                <div className="px-timeline__item">
                                                    <span className="px-timeline__dot"><MapPin size={12} /></span>
                                                    <div className="px-timeline__body">
                                                        <div className="px-timeline__title">{sendercityName} - {sendercountryname}</div>
                                                        <div className="px-timeline__act">{sendermobilenumber}, {senderAddress}, {sendercityName}, {sendercountryname} - {senderPostalcode}</div>
                                                    </div>
                                                </div>
                                                <div className="px-timeline__item">
                                                    <span className="px-timeline__dot"><MapPin size={12} /></span>
                                                    <div className="px-timeline__body">
                                                        <div className="px-timeline__title">{receivercityName} - {receivercountryname}</div>
                                                        <div className="px-timeline__act">{receivermobilenumber}, {receiverAddress}, {receivercityName}, {receivercountryname} - {receiverPostalcode}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            }
                            <section className="px-mb">
                                <h5 className="px-section-title">Summary</h5>
                                <div className="px-card">
                                    <div className="px-card__body">
                                        <div className="px-kv px-kv--stack">
                                            <div className="px-kv__item">
                                                <div className="px-kv__label">Shipment Product Type</div>
                                                <div className="px-kv__value">{product_Type}</div>
                                            </div>
                                            <div className="px-kv__item">
                                                <div className="px-kv__label">Order Mode</div>
                                                <div className="px-kv__value">{paymenttype}</div>
                                            </div>
                                            <div className="px-kv__item">
                                                <div className="px-kv__label">Insurance Type</div>
                                                <div className="px-kv__value">{insurance}</div>
                                            </div>
                                            <div className="px-kv__item">
                                                <div className="px-kv__label">Total Weight {help("Total physical weight of shipment")}</div>
                                                <div className="px-kv__value">{packages[0].Weight} KG</div>
                                            </div>
                                            <div className="px-kv__item">
                                                <div className="px-kv__label">Volumetric Weight {help("Volumetric Weight is calculated by HxWxL/5000")}</div>
                                                <div className="px-kv__value">{servicelist != undefined && servicelist.length > 0 && servicelist[0].volumetricweight}KG</div>
                                            </div>
                                        </div>
                                        <div className="px-summary-total">
                                            <span>Total Chargeable Weight</span>
                                            <span className="fw-bold">{servicelist != undefined && servicelist.length > 0 && servicelist[0].volumetricweight} KG</span>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {selectedservicelist != undefined && selectedservicelist.totalprice >= 0 &&
                                <section className="px-mb">
                                    <h6 className="px-section-title">Shipping Cost Breakup</h6>
                                    <div className="px-card">
                                        <div className="px-card__body">
                                            <table className="table table-sm mb-0">
                                                <tbody>
                                                    {selectedservicelist != undefined && selectedservicelist.service_charge > 0 &&
                                                        <tr><td>Freight Cost</td><td className="text-end">{selectedservicelist != undefined && selectedservicelist.service_charge}</td></tr>}
                                                    {selectedservicelist != undefined && selectedservicelist.totalFuelsurchage > 0 &&
                                                        <tr><td>Fuel Surcharge</td><td className="text-end">{selectedservicelist != undefined && selectedservicelist.totalFuelsurchage}</td></tr>}
                                                    {selectedservicelist != undefined && selectedservicelist.custom_clearence > 0 &&
                                                        <tr><td>Custom Clearance</td><td className="text-end">{selectedservicelist != undefined && selectedservicelist.custom_clearence}</td></tr>}
                                                    {selectedservicelist != undefined && selectedservicelist.codCharge > 0 &&
                                                        <tr><td>COD</td><td className="text-end">{selectedservicelist != undefined && selectedservicelist.codCharge}</td></tr>}
                                                    {selectedservicelist != undefined && selectedservicelist.insurance_chagre > 0 &&
                                                        <tr><td>Insurance</td><td className="text-end">{selectedservicelist != undefined && selectedservicelist.insurance_chagre}</td></tr>}
                                                    {selectedservicelist != undefined && selectedservicelist.esscharge > 0 &&
                                                        <tr><td>ESS Surcharge</td><td className="text-end">{selectedservicelist != undefined && selectedservicelist.esscharge}</td></tr>}
                                                    {selectedservicelist != undefined && selectedservicelist.elevated_risk_charge > 0 &&
                                                        <tr><td>Elevated Risk</td><td className="text-end">{selectedservicelist != undefined && selectedservicelist.elevated_risk_charge}</td></tr>}
                                                    {selectedservicelist != undefined && selectedservicelist.restricted_destination > 0 &&
                                                        <tr><td>Restricted Destination</td><td className="text-end">{selectedservicelist != undefined && selectedservicelist.restricted_destination}</td></tr>}
                                                    {selectedservicelist != undefined && selectedservicelist.remoterareadelivery > 0 &&
                                                        <tr><td>Remote Area Delivery</td><td className="text-end">{selectedservicelist != undefined && selectedservicelist.remoterareadelivery}</td></tr>}
                                                    {selectedservicelist != undefined && selectedservicelist.service_tax_val > 0 &&
                                                        <tr><td>GST - {selectedservicelist != undefined && selectedservicelist.service_tax}%</td><td className="text-end">{selectedservicelist != undefined && selectedservicelist.service_tax_val}</td></tr>}
                                                    {selectedservicelist != undefined && selectedservicelist.vat_tax_val > 0 &&
                                                        <tr><td>VAT - {selectedservicelist != undefined && selectedservicelist.vat_tax}%</td><td className="text-end">{selectedservicelist != undefined && selectedservicelist.vat_tax_val}</td></tr>}
                                                    <tr className="fw-bold"><td>Total</td><td className="text-end">{selectedservicelist != undefined && selectedservicelist.totalprice}</td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </section>
                            }

                            {selectedservicelist != '' && (
                                setloader == false ? (
                                    <div className="px-mb">
                                        <button type="button" className="px-btn px-btn--primary px-btn--block" onClick={() => createshipment()}>Create Shipment</button>
                                    </div>
                                ) : (
                                    <div className="px-mb">
                                        <button className="px-btn px-btn--primary px-btn--block" disabled><Loader2 size={16} className="px-spin" /> Creating…</button>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
        </>
    )
}

function Createshipment() {
    return (
        <>
            <LeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                <CreateShipmentContent />
                <Footer />
            </main>
        </>
    );
}
export default Createshipment;
